module.exports = __webpack_public_path__ + "static/template2-25705c98187eb915d2d446283b231897.png";